import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Boy = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 48 48"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <g clipPath="url(#Boy_svg__a)">
        <path
          fill="#ECEFF1"
          d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24"
        />
        <path
          fill="#455A64"
          d="M41.463 38.034a8.9 8.9 0 0 0-3.696-1.707l-6.579-1.32c-.69-.132-1.188-.75-1.188-1.47v-1.509c.423-.594.822-1.383 1.239-2.208.324-.639.813-1.602 1.056-1.851 1.332-1.338 2.619-2.841 3.018-4.779.372-1.818.006-2.772-.423-3.54 0-1.917-.06-4.317-.513-6.063-.054-2.364-.483-3.693-1.563-4.857-.762-.825-1.884-1.017-2.787-1.17-.354-.06-.843-.144-1.023-.24-1.599-.864-3.18-1.287-5.067-1.32-3.951.162-8.808 2.676-10.434 7.158-.504 1.365-.453 3.606-.411 5.406l-.039 1.083c-.387.756-.768 1.716-.393 3.54.396 1.941 1.683 3.447 3.039 4.803.222.228.723 1.2 1.053 1.842.423.822.825 1.608 1.248 2.199v1.509a1.49 1.49 0 0 1-1.194 1.47l-6.585 1.32c-1.371.291-2.643.879-3.684 1.704a1.5 1.5 0 0 0-.561 1.056 1.5 1.5 0 0 0 .384 1.128C10.842 45.162 17.271 48 24 48s13.161-2.835 17.64-7.782a1.499 1.499 0 0 0-.177-2.184"
        />
      </g>
      <defs>
        <clipPath id="Boy_svg__a">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Boy;
